/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState ,useEffect} from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import { Link } from 'react-router-dom';
import GlobalContext from '../../../components/Context/GloablContext';
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import  { handleSidebarPrvState } from '../../../redux/systemConfigSlice';
import FilterTemplate from './filterTemplate';
import TemplateExport from './TemplateExport';
import HelpGuideModal from '../../../components/HelpGuideModal';
import {useGetHelpGuideAdminQuery} from '../../../features/patientSlice'

const TopBarTemplate = ({
    title,
    path,
    AddButton,
    handleApplyFilter,
    buttonName,
    ApplyFilter,
    setFilterValues,
    filterValues,
    initialState,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    toAddScreen,
    isExport,
    handleCheckboxChange,
    setConfirmationState,
    data,
    exportUsers}) => {
    const {setToastErrorMessage,isSideBar,setIsAdvancedSearchOpen,setIsSideBar} = useContext(GlobalContext);
 
    const dispatch=useDispatch()
    const [searchParams, setSearchParams] = useSearchParams()
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [isChangeStatusOPen, setIsChangeStatusOpen] = useState(false)
    const [isChangeStatusOPenxl, setIsChangeStatusOpenxl] = useState(false)
    const [dateError, setdateError] = useState(false)

    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    

    const [isHover, setIsHover] = useState(false)
    const outSideClick = useRef();
    const filtervals = useSelector(state => state?.systemConfigData?.filterState)
    const ref = useRef()
    const ref2 = useRef()
    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=corporate-list-monitoring-template');
        } else {
            setQueryParamsadmin('type=admin-list-monitoring-templates');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    
    function generateArray(searchParams, object) {
        const result = {};
      
        const keysToCheck = ['start_date', 'end_date'];
      
        for (const key of keysToCheck) {
            if (searchParams[key]) {
                const values = searchParams[key].split(',')[0];
                result[key] = values;
            } else if (Object.keys(filtervals).length !== 0&&object?.hasOwnProperty(key)) {
                result[key] = object[key];
            }
        }
      
        return result;
    }
    function getSearchParams() {
        const searchParams = new URLSearchParams(window.location.search);
        const result = {};
      
        searchParams.forEach((value, key) => {
            result[key] = value;
        });
      
        return result;
    }
    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    })

    useOnClickOutside(ref2, () => {
        setIsChangeStatusOpenxl(false)
    })

    const handleOpenFilter = () => {
        setdateError(false)
     
        // Check for reading_type, status, filter_start_date, and filter_end_date
        if ((searchParams.get("start_date") !== null || searchParams.get("end_date") !== null) && !isFilterOpen) {
            setFilterValues((prevFilterValues) => ({
                ...prevFilterValues,
                ...filtervals,
            }));
            
        } else if (searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
            setFilterValues({
                "filter_start_date": '',
                "filter_end_date": '',
            });
        }
    
        setIsFilterOpen(!isFilterOpen);
    };

    

    // Function to handle onClick logic
    const handleSearchClick = () => {  
        // Store the current isSideBar state in Redux
        dispatch(handleSidebarPrvState(isSideBar));
      
        // Update the states after storing the previous state
        setIsAdvancedSearchOpen(true);
        setIsSideBar(false);
    };
    
    return (
        <div className="flex justify-between items-center mb-[14px]">
            <div className='flex items-center' style={{width:'-webkit-fill-available'}}>
                <h1 className="text-xl font-normal text-[#000000]  2xl:pt-0 pt-2 self-start 2xl:self-center" >{title}</h1>
                {
                    userType !=='super-admin' &&
                    <span onClick={() => setHelpGuideModel(true)} className='ml-2 min-w-fit cursor-pointer'>
                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                    </span> 
                }

            </div>

           
                  
                
            <div className="flex items-center w-full justify-end relative 2xl:flex-nowrap flex-wrap">
              
                <div className='flex items-center 2xl:flex-nowrap flex-wrap justify-end'>
                    <button id='search-btn' onClick={handleSearchClick} className="ml-2.5 border border-[#972E4C] rounded-[15px] px-[11px] py-[11px] min-w-max 2xl:mb-0 mb-2.5">
                        <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" className=''/>
                    </button>
                    
                    {(ApplyFilter !== undefined && ApplyFilter) &&
                        <FilterTemplate
                            isFilterOpen={isFilterOpen}
                            setIsFilterOpen={setIsFilterOpen}
                            handleApplyFilter={handleApplyFilter}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                            initialState={initialState}
                            handleOpenFilter={handleOpenFilter} 
                            handleCheckboxChange={handleCheckboxChange}
                            dateError={dateError}
                            setdateError={setdateError}
                        />
                    }
                    {(isExport)&&data!==undefined&&data?.data?.length>0&&<div className='2xl:mb-0 mb-2.5'>  <TemplateExport 
                        exportUsers={exportUsers}
                        exportCols={exportCols}
                        setIsFilterOpen={setIsFilterOpen}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                    />
                    </div>}
                    {AddButton && 
                    <>{<Link to={toAddScreen} state={{"limit":searchParams.get("limit"),"page_number":searchParams.get("page_number"),"search_mode":searchParams.get("search_mode"),'search':searchParams.get("search")?searchParams.get("search"):''}}>
                        <button type='button'
                            id="Add user"
                            className={`py-2.5 px-4 flex items-center text-lg font-normal text-[#fff] rounded-[16px] ml-2.5 
        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] 2xl:w-[197px] 2xl:mb-0 mb-2.5`} style={{'width':'max-content'}}>
                            <span className="mr-2.5"><img src="/images/add_Icon_white.svg" alt="img" /></span>
                            <span>{buttonName}</span> 
                        </button>
                    </Link>}</>}
                    {(helpGuideModel && helpguidestatus==="fulfilled") &&
                    <HelpGuideModal
                        setHelpGuideModel={setHelpGuideModel}
                        pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                    />
                    }
                </div>
            </div>
        </div>
    );
}

export default TopBarTemplate;
